import React, { useState } from "react";
import { Button, Dropdown, Menu, Modal } from "antd";
import { getJRTTAuthUrlV2 } from "@/services/api/ewaybillAuth";
import { DownOutlined } from "@ant-design/icons";
import EwaybillType from "@/enum/EwaybillType";
import AutoLoadingButton from "@/components/AutoLoadingButton";

import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { useModalStore } from "@/hooks/Modal/hooks";
import { delay } from "@/util";

interface DyEwaybillAuthDialogProps extends InjectBaseModalProps {}

const DyEwaybillAuthDialog: React.FC<DyEwaybillAuthDialogProps> = React.memo(function (props) {
  const { visible, onCancel } = props;

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      title="授权使用抖音站外电子面单"
      cancelText="关闭"
      okButtonProps={{
        hidden: true,
      }}
      width={600}
    >
      <div className="mb30">
        <p className="mb10">
          <span className="text-error mr10">第一步：请先在当前浏览器内登录抖音站外电子面单账号</span>
          <Button
            type="primary"
            onClick={() => {
              window.open("https://ebill.douyinec.com/login", "_blank");
            }}
          >
            去登录
          </Button>
        </p>
        <p style={{ fontSize: 13 }}>
          【温馨提示】抖音站外电子面单是指没有抖店的商家开通的站外电子面单账号，需先注册开通后可以授权使用。
          <a
            href="https://qw15p3s8hv.feishu.cn/wiki/wikcnNqNHjecG4JNMoWiQzKiZLb"
            title="《如何申请开通抖音电商/站外电子面单》"
            target="_blank"
          >
            点击这里查看开通教程链接
          </a>
        </p>
      </div>
      <div className="mb30">
        <p className="mb10">
          <span className="text-error mr10">第二步：需要订购【发货易】软件，已订购可忽略此步</span>
          <Button
            type="primary"
            onClick={() => {
              window.open("https://fuwu.jinritemai.com/detail?service_id=4&from=yinliu", "_blank");
            }}
          >
            去订购
          </Button>
        </p>
        <p style={{ fontSize: 13 }}>【温馨提示】按抖音官方使用规则，站外电子面单账号需要订购打单软件</p>
      </div>
      <div>
        <span className="text-error mr10">第三步：确认授权</span>

        <AutoLoadingButton
          type="primary"
          onClick={async () => {
            const { url } = await getJRTTAuthUrlV2("/ewaybillAccount", true);

            const sso = window.open("https://fuwu.jinritemai.com/appList?login_type=2", "_blank");

            await delay(3500);

            sso.window.close();

            window.location.href = url;

            onCancel();
          }}
        >
          去授权
        </AutoLoadingButton>
      </div>
    </Modal>
  );
});

interface DyEwaybillAuthButtonProps {}

const DyEwaybillAuthButton: React.FC<DyEwaybillAuthButtonProps> = function (props) {
  const modalStore = useModalStore();

  const [loading, setLoading] = useState(false);

  async function handleMenuClick({ key }) {
    if (key === EwaybillType.JINRITEMAI) {
      setLoading(true);

      try {
        const { url } = await getJRTTAuthUrlV2();

        window.location.href = url;
      } finally {
        setLoading(false);
      }
    } else if (key === EwaybillType.JINRITEMAI_AUTH) {
      modalStore.openModal(DyEwaybillAuthDialog);
    }
  }

  return (
    <Dropdown
      disabled={loading}
      overlay={() => {
        return (
          <Menu onClick={handleMenuClick}>
            <Menu.Item key={EwaybillType.JINRITEMAI}>
              <span>授权使用抖音店铺电子面单</span>
            </Menu.Item>
            <Menu.Item key={EwaybillType.JINRITEMAI_AUTH}>
              <span>授权使用抖音站外电子面单</span>
            </Menu.Item>
          </Menu>
        );
      }}
    >
      <Button className="mr10 btn-success" loading={loading}>
        授权使用抖音电子面单
        <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default React.memo(DyEwaybillAuthButton);
